module.exports = __webpack_public_path__ + "veterans-icon-7f2e920756bf6bde1d68aab5763d18a6.svg";


//////////////////
// WEBPACK FOOTER
// ../images/veterans-icon.svg
// module id = 1257
// module chunks = 4 5